import React from 'react'
import { Typography, Button, message } from 'antd'
import { FormComponent } from '../../../BaseComponent'
import { ConnectRequest } from '../../../../services/integration/interfaces/ApiRequest'

type IntegrationAuthProps = {
  integrationUuid: string,
  error: any | null,
  
  loading: boolean,
  history: any,

  makeConnection: (args: ConnectRequest) => Promise<any>
}

export default class IntegrationConnect extends FormComponent<IntegrationAuthProps> {

  componentDidUpdate(prevProps: IntegrationAuthProps) {
    const wasLoading = prevProps.loading && !this.props.loading

    if (wasLoading) {
      if (this.props.error) {
        message.error(`Could not establish connection with software partner. Reason: ${this.props.error}`)
      } else {
        this.props.history.replace(`/integration/${this.props.integrationUuid}`)
      }
    }
  }

  handleConnect = () => {
    const { integrationUuid, makeConnection } = this.props

    makeConnection({
      integration_uuid: integrationUuid
    })
  }

  render() {
    const { loading } = this.props

    return (
      <div>
        <Typography.Title level={3}>
          We are ready for establish connection!
        </Typography.Title>

        <Button type="primary" loading={loading} onClick={this.handleConnect}>
          CONNECT
        </Button>
      </div>
    )
  }
}
